import * as React from "react";
import { Text, View } from "react-native";
import * as DocumentPicker from "expo-document-picker";
import { Feather } from "@expo/vector-icons";
import { decodeEntity } from "html-entities";
import { useWatch } from "react-hook-form";

import { getFileFormat } from "~/utils/getFileFormat";
import {
  SaveFormValues,
  useSaveFormContext,
} from "~/components/SaveForm/shared";
import { icons } from "~/lib/constants";
import { formatBytes } from "~/lib/utils";

export function FilePreviewCard() {
  const fileMeta = useWatch<SaveFormValues, "fileMeta">({
    name: "fileMeta",
  });

  const { setValue } = useSaveFormContext();
  if (!fileMeta) return null;

  return (
    <View className="flex-row gap-4">
      <View className="flex-1 gap-2">
        <View className="flex-row items-center gap-2">
          <Feather
            name={icons.file.web}
            className="text-text-primary"
            size={18}
          />
          <View className="flex-row items-center gap-1">
            {fileMeta?.name && (
              <Text
                numberOfLines={1}
                ellipsizeMode="tail"
                className="text-text-primary shrink font-semibold"
              >
                {fileMeta.name}
              </Text>
            )}
          </View>
        </View>
        <View>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            className="text-text-secondary shrink text-sm"
          >
            {getFileFormat(fileMeta?.mimeType)} {decodeEntity("&bull;")}{" "}
            {formatBytes(fileMeta.size ?? 0)}
          </Text>
        </View>

        <Text
          className="text-text-brand"
          role="button"
          onPress={async () => {
            try {
              const result = await DocumentPicker.getDocumentAsync();

              if (!result.canceled) {
                const asset = result.assets[0];
                setValue("fileMeta", {
                  name: asset?.name ?? "",
                  uri: asset?.uri ?? "",
                  mimeType: asset?.mimeType ?? "",
                  size: asset?.size ?? 0,
                });
              }
            } catch (e) {
              console.error(e);
            }
          }}
        >
          Select another
        </Text>
      </View>
    </View>
  );
}
